<template>
  <a-row :gutter="10">
    <a-col :md="leftColMd" :sm="24" style="margin-bottom: 20px">
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item :label="language['platform.roleUser.columns.roleName']" :labelCol="{span: 5}" :wrapperCol="{span: 18, offset: 1}">
              <a-input placeholder="" v-model="queryParam.roleName" allowClear></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
               <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">

    </div>

    <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
      <i class="anticon anticon-info-circle ant-alert-icon">
      </i> {{language['common.choosed']}} <a><b>{{ selectedRowKeys.length }}</b></a>{{language['common.item']}}
      <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
    </div>

    <!-- table区域-begin -->
    <div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="roleId"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type:'radio'}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleCostcodes(record.roleId,record.roleKey,record.roleName)" v-has="'CmsRoleCostcodeList:bind'">{{language['emp.roleCostcode.costcodeBind']}}</a>
          <a-divider type="vertical" />
          <a @click="handleCmsCols(record)">{{language['emp.roleCostcode.col']}}</a>
        </span>

      </a-table>
    </div>

    <cms-role-costcode-modal ref="modalForm" @ok="modalFormOk"></cms-role-costcode-modal>
    <cms-role-costcode-bind-modal ref="bindModalForm" @ok="modalFormOk"></cms-role-costcode-bind-modal>
  </a-card>
    </a-col>
    <a-col :md="rightColMd" :sm="24" v-if="this.rightcolval == 1" style="max-height: 100vh;overflow-y:scroll;overflow-x: hidden;">
      <a-card :bordered="false">
        <div style="text-align: right;">
          <a-icon type="close-circle" @click="hideCmsCol" />
        </div>
        <template>
            <span style="user-select: none">
              <a-tree
                :show-line="true"
                :show-icon="false"
                :treeData="cmsColTree"
                :expandedKeys="iExpandedKeys"
                :autoExpandParent="autoExpandParent"
                @expand="onExpand"
                :replaceFields="{ children: 'children', title: 'label', key: 'id' }"
                :checkedKeys="checkedKeys"
                :checkStrictly="checkStrictly"
                checkable
              >

              </a-tree>
            </span>
        </template>
      </a-card>
      <div class="drawer-bootom-button">
        <a-dropdown :trigger="['click']" placement="topCenter">
          <a-menu slot="overlay">
            <a-menu-item key="5" @click="expandAll">{{language['system.expenseall']}}</a-menu-item>
            <a-menu-item key="6" @click="closeAll">{{language['system.collegeall']}}</a-menu-item>
          </a-menu>
          <a-button>
            {{language['system.treeoperate']}} <a-icon type="up" />
          </a-button>
        </a-dropdown>
      </div>
    </a-col>
  </a-row>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import CmsRoleCostcodeModal from './modules/CmsRoleCostcodeModal'
  import CmsRoleCostcodeBindModal from './modules/CmsRoleCostcodeBindModal'
  import { getAction } from '@/api/manage'

  export default {
    name: 'CmsRoleCostcodeList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      CmsRoleCostcodeModal,
      CmsRoleCostcodeBindModal
    },
    data () {
      return {
        description: 'cms_role_costcode管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          /*{
            title:'cms角色id',
            align:"center",
            dataIndex: 'roleId'
          },*/
          {
            title:this.$store.getters.language['emp.roleCostcode.roleCode'],
            align:"center",
            dataIndex: 'roleKey'
          },
          {
            title:this.$store.getters.language['emp.roleCostcode.roleName'],
            align:"center",
            dataIndex: 'roleName'
          },
          {
            title: this.$store.getters.language['common.action'],
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/hhemp/basedatacms/cmsrolecostcodes",
          delete: "/hhemp/basedatacms/cmsrolecostcode",
          deleteBatch: "/hhemp/basedatacms/cmsrolecostcode/batch",
          exportXlsUrl: "/hhemp/basedatacms/export-xls",
          importExcelUrl: "hhemp/basedata/import-excel",
          
        },
        dictOptions:{},
        superFieldList:[],
        rightcolval:0,
        selectedRowKeys: [],
        cmsColTree: [],
        iExpandedKeys: [],
        autoExpandParent: true,
        allTreeKeys:[],
        selectionRows: [],
        checkedKeys: [],
        checkStrictly: true,
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      leftColMd() {
        return this.selectedRowKeys.length === 0 ? 24 : 18
      },
      rightColMd() {
        return this.selectedRowKeys.length === 0 ? 0 : 6
      },
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      initDictConfig(){
      },
      handleCostcodes(roleId,roleKey,roleName){
        this.$refs.bindModalForm.roleCostcodeSet(roleId,roleKey,roleName);
        this.$refs.bindModalForm.title = this.language['emp.roleCostcode.costcodeBind'];
      },
      handleCmsCols(record){
          this.rightcolval = 1
          this.selectedRowKeys = [record.roleId]
          this.loadTree()
      },
      loadTree() {
        var that = this
        that.cmsColTree = []
        let langCode = window.sessionStorage.getItem('USER_LANGUAGE');
        getAction("/hhemp/CmsAPI/catalogTreeData",{roleId: this.selectedRowKeys[0], i18n: langCode, siteId: process.env.VUE_APP_EMP_CMS_SITEID}).then((res)=>{
          if (res.success) {
            that.allTreeKeys = [];
            that.cmsColTree = res.result.treeData;
            that.checkedKeys = res.result.idList;
            for (let i = 0; i < res.result.treeData.length; i++) {
                let temp = res.result.treeData[i]
                that.getAllKeys(temp);
            }
            this.iExpandedKeys = that.allTreeKeys;
          }
        })
      },
      onExpand(expandedKeys) {
        this.iExpandedKeys = expandedKeys
        this.autoExpandParent = false
      },
      hideCmsCol(){
        this.selectedRowKeys = []
      },
      expandAll () {
        this.iExpandedKeys = this.allTreeKeys
      },
      closeAll () {
        this.iExpandedKeys = []
      },
      getAllKeys(node) {
        this.allTreeKeys.push(node.id)
        if (node.children && node.children.length > 0) {
          for (let a = 0; a < node.children.length; a++) {
            this.getAllKeys(node.children[a])
          }
        }
      },
      onSelectChange(selectedRowKeys, selectionRows) {
        this.rightcolval = 1
        this.selectedRowKeys = selectedRowKeys
        this.selectionRows = selectionRows
        this.model1 = Object.assign({}, selectionRows[0])
        this.currentRoleId = selectedRowKeys[0]
        this.loadTree()
      },
      onClearSelected() {
        this.selectedRowKeys = []
        this.selectionRows = []
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';

  .drawer-bootom-button {
    /*position: absolute;*/
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: left;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
</style>
